import { AbilitySubjectType, AbilitySubjectsRegistry } from '@core/shared/ability';
import { DevToolsRegistry } from '../dev-tools';
import { ModelRegistryService } from '../model';
import { FeatureRegistry } from '@core/shared/feature';
import * as i0 from "@angular/core";
import * as i1 from "@core/shared/feature";
import * as i2 from "../model";
import * as i3 from "../dev-tools";
export let FrontendAbilitySubjectsRegistry = /*#__PURE__*/(() => {
  class FrontendAbilitySubjectsRegistry extends AbilitySubjectsRegistry {
    constructor(features, models, debug) {
      super(features, models);
      this.features = features;
      this.models = models;
      this.debug = debug;
      debug.exposeDebugFunction(['Abilities', 'Inspect Registered Subjects'], () => {
        return Object.values(AbilitySubjectType).reduce((data, type) => {
          const typeMap = this.registry[type];
          const keys = Array.from(typeMap.keys()).sort();
          const orderedObject = keys.reduce((ordered, key) => {
            ordered[key] = typeMap.get(key);
            return ordered;
          }, {});
          data[type] = orderedObject;
          return data;
        }, {});
      });
      debug.exposeDebugFunction(['Abilities', 'Inspect Registered Actions'], () => {
        return this.getAllActions();
      });
    }
    static {
      this.ɵfac = function FrontendAbilitySubjectsRegistry_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FrontendAbilitySubjectsRegistry)(i0.ɵɵinject(i1.FeatureRegistry), i0.ɵɵinject(i2.ModelRegistryService), i0.ɵɵinject(i3.DevToolsRegistry));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: FrontendAbilitySubjectsRegistry,
        factory: FrontendAbilitySubjectsRegistry.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return FrontendAbilitySubjectsRegistry;
})();